'use client';

import {useEffect} from 'react';

export default function HeadlessUiDocumentPaddingObserver() {
  // inspired by https://github.com/tailwindlabs/headlessui/pull/2328/files
  // need to offset stuff sometimes due to popups from headless ui
  useEffect(() => {
    if (!window.MutationObserver) {
      return;
    }

    const observedElement = document.documentElement;

    const observer = new MutationObserver(() => {
      const rightPadding = observedElement.style.paddingRight;

      document.body.style.setProperty(
        '--html-padding-right',
        rightPadding || '0px',
      );
    });

    observer.observe(observedElement, {
      attributes: true,
      attributeFilter: ['style'],
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return null;
}
